<template>
  <div id="app">
    <!-- TODO

Display the Error message for <1 or >1 role (already calculated)

RULES: change so that people who are logged in but not participants cannot write to STATUS etc, stops them writing gibberish and filling up FB.

-->

    <!-- Formatting HTML in Vue is best by installing prettier, DISABLING prettier for Vue files, and then telling VETUR to use Prettier for HTML and CSS
https://github.com/vuejs/vetur/blob/master/docs/formatting.md
-->

    <section v-if="amOnline === false">
      <AppOfflineWarning> </AppOfflineWarning>
    </section>

    <section v-if="loggedState !== 'in'">
      <!-- Only for non-logged in states -->
      <AppAutoupdate :canUpdateNow="true"></AppAutoupdate>
    </section>

    <section v-if="loggedState === undefined" class="center-container">
      <img
        style="width: 50vw"
        src="../assets/Orbita-2-Logo.jpg"
        alt="Orbita-2 Logo"
      />
    </section>

    <section v-if="loggedState === 'out'">
      <div class="header-logged-out">
        <div>&nbsp;</div>
        <div>
          <img
            style="max-width: 15em; max-height: 100%"
            src="../assets/Orbita-2-Logo.jpg"
            alt="Orbita-2 Logo"
          />
        </div>
        <div>&nbsp;</div>
      </div>
      <div class="main">
        <b-form @submit="tryLogin(email, password)">
          <h2>Please log in</h2>
          <div v-if="loginErr.message" class="err-font err-container">
            <br />
            {{ loginErr.message }}
            <br /><br />
          </div>
          <br />
          <div style="font-family: 'Courier New', monospace" class="px-3">
            <b-input
              v-model="email"
              placeholder="email"
              type="text"
              style="width: 100%; padding: 0.5em"
            />
            <br />
            <b-input
              v-model="password"
              type="password"
              placeholder="password"
              style="width: 100%; padding: 0.5em"
            />
          </div>

          <br />
          <b-button
            size="lg"
            variant="primary"
            @click="tryLogin(email, password)"
            >Log in</b-button
          >

          <br />
          <br />
          <b-button size="sm" variant="link" @click="tryForgotPassword(email)"
            >Forgot password</b-button
          >

          <br />
          <div
            v-if="showSpinner"
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <SpinnerTrinity> </SpinnerTrinity>
          </div>

          <br />
          <br />
          <br />
          <br />

          <h2>Joining the trial?</h2>
          <div style="max-width: 20em; margin: auto; text-align: left">
            <ul>
              <li v-if="!(email.includes('@') && email.includes('.'))">
                Enter your email above.
              </li>
              <li v-if="password.length < 6">
                Create a password<br />(at least 6 characters)
              </li>
              <li>
                Click here >
                <b-button
                  size="small"
                  class="btn btn-secondary"
                  v-on:click="trySignup(email, password)"
                  >Enrol me</b-button
                >
              </li>
            </ul>
          </div>
        </b-form>
      </div>
    </section>

    <div
      v-if="
        loggedState === 'in' && user.privilegesIsLoaded && user.contactIsLoaded
      "
    >
      <section
        v-if="
          !user.privilegesObj.participant &&
          !user.privilegesObj.blindedResearcher &&
          !user.privilegesObj.unblindedResearcher
        "
        style="min-height: 90vh"
      >
        <AppAwaitingApproval> </AppAwaitingApproval>
      </section>

      <section
        v-if="
          user.privilegesObj.participant &&
          participant.privilegesIsLoaded &&
          participant.statusIsLoaded &&
          participant.contactIsLoaded
        "
      >
        <div v-if="participantSufficientInfo.all" style="min-height: 90vh">
          <div v-if="participant.statusObj.trained">
            <HeaderBand
              :name="
                typeof participant.contactObj.shortName === 'string'
                  ? participant.contactObj.shortName
                  : 'Name not given yet'
              "
            ></HeaderBand>
            <SymptomEntry
              v-bind:participant="participant"
              entryMode="live"
            ></SymptomEntry>
          </div>
          <div v-else>
            <HeaderBand name="Practice Mode"></HeaderBand>
            <SymptomEntry
              v-bind:participant="participant"
              entryMode="practice"
            ></SymptomEntry>
          </div>
        </div>
      </section>

      <section
        v-if="
          user.privilegesObj.blindedResearcher ||
          user.privilegesObj.unblindedResearcher
        "
        style="min-height: 90vh"
      >
        <HeaderBand
          :name="user.contactObj.shortName"
          :privileges="user.privilegesObj"
          :email="user.presenceObj.emailAtLastLogin"
        >
        </HeaderBand>

        <ResView
          v-bind:user="user"
          v-bind:participant="participant"
          v-bind:bindParticipantToAUserId="bindParticipantToAUserId"
        >
        </ResView>
        <!-- USER is the RESEARCHER -->
      </section>

      <section
        v-if="
          !participantSufficientInfo.all &&
          participant.statusIsLoaded &&
          user.privilegesObj.participant
        "
        style="min-height: 90vh"
      >
        <AppPrivacy
          :displayName="user.contactObj.shortName"
          :participantSufficientInfo="participantSufficientInfo"
          @gave-permission="
            participant.statusRef.child('privacy/agree').set('yes');
            participant.statusRef
              .child('privacy/agreeDate')
              .set(new Date().toISOString());
          "
          @refused-permission="trySignOut()"
        >
        </AppPrivacy>
      </section>

      <AppHelp
        @trySignOut="trySignOut"
        :myAnginaIs="participant.contactObj.myAnginaIs"
        :userId="user.id"
        :windowsQuestions="participant.contactObj.windows.questions"
        :privileges="user.privilegesObj"
      >
      </AppHelp>
    </div>

    <pre>


<!--
DEVELOPER INFO (only shown during testing)

user
{{user}}

participantSufficientInfo
{{participantSufficientInfo}}

participant
{{participant}}
-->

</pre>
  </div>
</template>

<script>
/* eslint-disable standard/computed-property-even-spacing */

import AppAutoupdate from "./AppAutoupdate.vue";
import AppOfflineWarning from "./AppOfflineWarning.vue";
import HeaderBand from "./HeaderBand.vue";
import AppPrivacy from "./AppPrivacy.vue";
import AppAwaitingApproval from "./AppAwaitingApproval.vue";
import SymptomEntry from "./SymptomEntry.vue";
import ResView from "./ResView.vue";
import AppHelp from "./AppHelp.vue";
import ActionSheet from "./from_st_elsewhere/ActionSheet.vue";
import SpinnerTrinity from "./from_st_elsewhere/SpinnerTrinity.vue";

// These roots then have branches per user
import {
  // Non- "this."
  auth,
  systemStatusRef,
  amOnlineRef,
  contactRootRef,
  privilegesRootRef,
  presenceRootRef,
  statusRootRef,
  ServerValueTIMESTAMP,
} from "../firebaseSetup.js";

const checkIntervalSeconds = 3600; // Every hour, reconsider whether we are up to date with data entry
const amOnlineSecondsBeforeCommenting = 10;

export default {
  data() {
    return {
      // Subset of THIS variables that you want to be reactive on the template.
      // These must all be referred to as "this.", in the Methods.
      jsActiveLongEnoughToTellOnlineStatus: false,
      loggedState: undefined,
      amOnline: undefined,

      email: "",
      password: "",
      loginErr: {},
      showSpinner: false,

      user: {
        // Person A, the person ACTUALLY LOGGED IN (who might be the participant or a researcher at HQ)
        id: String,

        presenceRef: {},
        //    presenceObj: {}, // no point reading this
        //    presenceIsLoaded: Boolean, // no point reading this

        privilegesRef: {},
        privilegesObj: {
          participant: Boolean,
          blindedResearcher: Boolean,
          unblindedResearcher: Boolean,
        },
        privilegesIsLoaded: Boolean,
      },

      participantAndUserBranchBindingTable: {}, // keep a list of what you are binding to PARTICIPANT's branches, so you can unbind them when no longer needed (i.e. when binding something else).
      participant: {
        // List the branches of PARTICIPANT that we want to be reactive to
        id: "",

        statusRef: {},
        statusObj: {
          trained: false,
          refresh: "dummyStringReplacedWithRandom",
        },
        statusIsLoaded: false,

        contactRef: {},
        contactObj: {
          shortName: "",
          startDateKey: "",
          myAnginaIs: "",
          windows: {
            dates: [],
            questions: [],
          },
        },
        contactIsLoaded: false,

        presenceRef: {},
        presenceObj: {},
        presenceIsLoaded: false,

        privilegesRef: {},
        privilegesObj: {
          participant: false,
          blindedResearcher: false,
          unblindedResearcher: false,
        },
        privilegesIsLoaded: false,
      },
    };
  },

  computed: {
    participantSufficientInfo: function () {
      const sufficiency = {};

      sufficiency.privilegesParticipant =
        this.participant.privilegesObj &&
        this.participant.privilegesObj.participant;

      sufficiency.statusPrivacy =
        this.participant.statusObj &&
        this.participant.statusObj.privacy &&
        this.participant.statusObj.privacy.agree &&
        this.participant.statusObj.privacy.agreeDate;

      sufficiency.contactShortName =
        this.participant.contactObj && this.participant.contactObj.shortName;

      sufficiency.contactTrialId =
        this.participant.contactObj && this.participant.contactObj.trialId;

      sufficiency.contactStartDateKey =
        this.participant.contactObj && this.participant.contactObj.startDateKey;

      sufficiency.contactMyAnginaIs =
        this.participant.contactObj &&
        this.participant.contactObj.myAnginaIs &&
        this.participant.contactObj.myAnginaIs.length >= 4;

      sufficiency.contactWindowQuestions =
        this.participant.contactObj &&
        this.participant.contactObj.windows &&
        this.participant.contactObj.windows.questions &&
        this.participant.contactObj.windows.questions.activity_001 &&
        this.participant.contactObj.windows.questions.activity_001.length >=
          3 &&
        this.participant.contactObj.windows.questions.activity_002 &&
        this.participant.contactObj.windows.questions.activity_002.length >= 3; // Arbitrarily require at least 3 characters for each activity. e.g. "run"

      sufficiency.all =
        sufficiency.privilegesParticipant &&
        sufficiency.statusPrivacy &&
        sufficiency.contactShortName &&
        sufficiency.contactTrialId &&
        sufficiency.contactStartDateKey &&
        sufficiency.contactWindowQuestions;
      return sufficiency;
    },
  },
  firebase: {
    systemStatus: systemStatusRef,
  },
  components: {
    AppOfflineWarning,
    HeaderBand,
    SymptomEntry,
    ResView,
    ActionSheet,
    SpinnerTrinity,
    AppAwaitingApproval,
    AppPrivacy,
    AppHelp,
    AppAutoupdate,
  },
  created() {
    auth.onAuthStateChanged((user) => this.updateLoggedState(user));

    setInterval(() => {}, checkIntervalSeconds * 1000);
  },
  methods: {
    tryLogin(email, password) {
      this.showSpinner = true;
      auth
        .signInWithEmailAndPassword(email.trim(), password.trim())
        .then(() => {})
        .catch((e) => {
          this.loginErr = e;
          throw new Error("Signin error:" + JSON.stringify(e));
        })
        .finally(() => {
          this.showSpinner = false;
        });
    },

    trySignup(email, password) {
      this.showSpinner = true;

      auth
        .createUserWithEmailAndPassword(email.trim(), password.trim())
        .then(() => {})
        .catch((e) => (this.loginErr = e))
        .finally(() => {
          this.showSpinner = false;
        });
    },

    trySignOut() {
      this.showSpinner = true;
      auth
        .signOut()
        .then(() => {})
        .catch((e) => (this.loginErr = e))
        .finally(() => {
          this.showSpinner = false;
        });
    },

    tryForgotPassword(email) {
      if (!email.includes("@") || !email.includes(".")) {
        this.loginErr = {
          message: "Enter your email and press 'Forgot password' again.",
        };
        return;
      }
      this.showSpinner = true;

      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          this.loginErr = {
            message:
              "We've just emailed you a password reset link. Please open your email and click the link from us.",
          };
        })
        .catch((e) => (this.loginErr = e))
        .finally(() => {
          this.showSpinner = false;
        });
    },

    updateLoggedState(userFromAuth) {
      // Have to use this type of function definition and not fat arrow, because fat arrow fails to make "this" equal to the Vue instance

      // In the end I did this instead of vueFire, because it is not so difficult to do one's own firebase bindings

      // -------------------------------------------------
      // Set based on who is LOGGED IN:
      //    this.user.contactRef - firebase reference
      //    this.user.contactObj - read-only object that is live-updated from firebase
      //    this.user.contactIsLoaded - whether the conctactObj has had its first reading from firebase yet
      //    this.user.presenceRef
      //    this.user.presenceObj
      //    this.user.presenceIsLoaded
      //    this.user.privilegesRef
      //    this.user.privilegesObj
      //    this.user.privilegesIsLoaded
      //
      // Separately, set based on who THE TARGET PARTICIPANT IS:
      //    this.participant.contactRef
      //    this.participant.contactObj
      //    this.participant.contactIsLoaded
      //    this.participant.presenceRef
      //    this.participant.presenceObj
      //    this.participant.presenceIsLoaded
      //    this.participant.privilegesRef
      //    this.participant.privilegesObj
      //    this.participant.privilegesIsLoaded
      //    this.participant.statusRef
      //    this.participant.statusObj
      //    this.participant.statusIsLoaded
      //
      // For PARTICIPANTS, the USER and PARTICIPANT objects point to the same things (themselves).
      // For HQ staff, they have an identity themselves (and presence etc) but can look at participants' data
      // -------------------------------------------------

      if (userFromAuth) {
        this.password = ""; // remove password after login

        this.loggedState = "in";
        this.user.id = userFromAuth.uid;
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
          "user",
          this.user,
          "contact",
          contactRootRef.child(this.user.id)
        );
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
          "user",
          this.user,
          "presence",
          presenceRootRef.child(this.user.id)
        );
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
          "user",
          this.user,
          "privileges",
          privilegesRootRef.child(this.user.id)
        );
        this.user.presenceRef.update({
          dLastLogin: ServerValueTIMESTAMP,
          emailAtLastLogin: userFromAuth.email,
        });
        amOnlineRef.on("value", (snapshot) => {
          if (snapshot.val()) {
            const instanceId =
              Math.random().toString(36).substring(2, 15) +
              Math.random().toString(36).substring(2, 15);

            this.user.presenceRef.onDisconnect().update({
              lastChangeWasOn: null,
              lastWentOff: ServerValueTIMESTAMP,
              ["currentSessions/" + instanceId]: null,
            });
            this.user.presenceRef
              .update({
                lastChangeWasOn: true,
                ["currentSessions/" + instanceId]: true,
              })
              .then(() => {
                this.amOnline = true;
              });
          } else {
            this.amOnline = false;
          }
        });
        setTimeout(() => {
          this.jsActiveLongEnoughToTellOnlineStatus = true;
        }, amOnlineSecondsBeforeCommenting * 1000);

        this.user.privilegesRef.on("value", (dummySnapshot) => {
          const numberOfPrivileges =
            (this.user.privilegesObj.participant ? 1 : 0) +
            (this.user.privilegesObj.blindedResearcher ? 1 : 0) +
            (this.user.privilegesObj.unblindedResearcher ? 1 : 0);

          if (numberOfPrivileges < 1) {
            this.errorState = {
              error: true,
              message:
                "Please ask the administrator to activate your account as a participant or a researcher. ",
            };
            return;
          }
          if (numberOfPrivileges > 1) {
            this.errorState = {
              error: true,
              message:
                "You account has been mistakenly labelled as more than one type of user. Please ask the administrator to set your account as either a participant or a researcher, but not both.",
            };
            return;
          }

          // Now we know there is only 1 privilege

          if (this.user.privilegesObj.participant) {
            this.bindParticipantToAUserId(this.user.id);
          } else {
            // They are a researcher, and will get their own web page which calls "bindParticipantToAUserId" when they select a participant
          }
        });
      } else {
        this.loggedState = "out";
      }
    },

    bindParticipantToAUserId(aParticipantsUserId) {
      this.participant.id = aParticipantsUserId;

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
        "participant",
        this.participant,
        "contact",
        contactRootRef.child(aParticipantsUserId)
      );

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
        "participant",
        this.participant,
        "status",
        statusRootRef.child(aParticipantsUserId)
      );

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
        "participant",
        this.participant,
        "presence",
        presenceRootRef.child(aParticipantsUserId)
      );

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
        "participant",
        this.participant,
        "privileges",
        privilegesRootRef.child(aParticipantsUserId)
      );
    },

    bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(
      participantOrUserString,
      participantOrUserObject,
      keyPrefix,
      firebaseRef
    ) {
      // "keyPrefix" can be, for example, "status"
      // That would create in participant, te efollowing:
      //   participant.statusRef    which would be the firebase Ref for the participant's status
      //   participant.statusObj    which would be the firebase-bound status
      //   participant.statusIsLoaded    which would be true once firebase first reads the data into the object

      // Step 1. Open up the pathway to that point in the table
      if (!this.participantAndUserBranchBindingTable) {
        this.participantAndUserBranchBindingTable = {};
      }
      if (!this.participantAndUserBranchBindingTable[participantOrUserString]) {
        this.participantAndUserBranchBindingTable[participantOrUserString] = {};
      }

      // Step 2. If this variable is already bound to a firebase node, unbind
      if (
        this.participantAndUserBranchBindingTable[participantOrUserString][
          keyPrefix
        ]
      ) {
        // If this keyPrefix is already bound to a firebase node, unbind it. Otherwise updates to teh OLD node will wrongly cause themselves to be read in and trigger an incorrect "update" to the new node, i.e. overwrite your new patient's data with the previous patient's data (just because the previous patient happened to update their data)
        this.participantAndUserBranchBindingTable[participantOrUserString][
          keyPrefix
        ].off();
        participantOrUserObject[keyPrefix + "IsLoaded"] = false;
      }

      // Step 3. Now bind to the new firebase node and store the three things, "REF","OBJ" itself, and "ISLOADED".
      this.participantAndUserBranchBindingTable[participantOrUserString][
        keyPrefix
      ] = firebaseRef;
      participantOrUserObject[keyPrefix + "Ref"] = firebaseRef;

      firebaseRef.on("value", (snapshot) => {
        // Every time firebase value changes (including the first where firebase just comes live) this will cause an Object.assign, causing a re-render of the object in this and the children components.

        let newKeyValuePair = {};
        let newValue = snapshot.val() || {};

        if (keyPrefix === "contact") {
          // Ensure contact has these branches
          if (!newValue.windows) {
            newValue.windows = {};
          }
          if (!newValue.windows.dates) {
            newValue.windows.dates = {};
          }
          if (!newValue.windows.questions) {
            newValue.windows.questions = {};
          }
        }

        newKeyValuePair[keyPrefix + "Obj"] = newValue;

        Object.assign(participantOrUserObject, newKeyValuePair);

        participantOrUserObject[keyPrefix + "IsLoaded"] = true;
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Oxygen");

body {
  margin: 0;
}

#app {
  font-family: "Oxygen", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main {
  text-align: center;
  margin-top: 40px;
}

.header-logged-out {
  margin: 1em;
  height: 20vh;
  padding: 0 16px 0 24px;
  background-color: #ffffff;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header-logged-in {
  margin: 0;
  height: 8vh;
  padding: 0 16px 0 24px;
  background-color: #ffffff;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

header span {
  font-size: 20px;
  line-height: 1;
  padding-top: 16px;
}

.err-font {
  background: pink;
  color: darkred;
}

.err-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em;
}

.center-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 1rem;
  margin-top: 0.5rem;
  padding: 1rem;
}

.spaced-button {
  margin: 0.5em;
}

pre {
  font-family: "Encode Sans", "Georgia", sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/App.vue